import { render, staticRenderFns } from "./SelectPicture.vue?vue&type=template&id=06e4c0af&scoped=true&"
import script from "./SelectPicture.vue?vue&type=script&lang=js&"
export * from "./SelectPicture.vue?vue&type=script&lang=js&"
import style0 from "./SelectPicture.vue?vue&type=style&index=0&id=06e4c0af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e4c0af",
  null
  
)

export default component.exports